import { RootContext } from 'contexts/rootContext';
import { useContext } from 'react';

export const useRootStore = () => {
  return useContext(RootContext);
};
